import React from 'react';

export default function DateCell({ value }) {
  return <span>{value || ''}</span>;
}
